var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "session-duration-chart" },
    [
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "left" }, [
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("message.chartView") },
                      expression: "{ content: $t('message.chartView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "" : "selected",
                    onClick: function () {
                      return (_vm.tableMode = false)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("insights")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("message.tableView") },
                      expression: "{ content: $t('message.tableView') }",
                    },
                  ],
                  attrs: {
                    classNames: _vm.tableMode ? "selected" : "",
                    onClick: function () {
                      return (_vm.tableMode = true)
                    },
                  },
                },
                [_c("md-icon", [_vm._v("table_view")])],
                1
              ),
              _vm._v(" "),
              _c(
                "IconButton",
                {
                  directives: [
                    {
                      name: "tippy",
                      rawName: "v-tippy",
                      value: { content: _vm.$t("message.download") },
                      expression: "{ content: $t('message.download') }",
                    },
                  ],
                  attrs: { onClick: _vm.exportToExcel },
                },
                [
                  _vm._v("\n>\n                        "),
                  _c("md-icon", [_vm._v("download")]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "middle" },
          [
            _c("label", [_vm._v(_vm._s(_vm.$t("report.aggregateAs")))]),
            _vm._v(" "),
            _c(
              "a-radio-group",
              {
                attrs: { size: "small" },
                model: {
                  value: _vm.aggregationType,
                  callback: function ($$v) {
                    _vm.aggregationType = $$v
                  },
                  expression: "aggregationType",
                },
              },
              [
                _c("a-radio-button", { attrs: { value: "avg" } }, [
                  _vm._v(_vm._s(_vm.$t("message.average"))),
                ]),
                _vm._v(" "),
                _c("a-radio-button", { attrs: { value: "total" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("report.total"))),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right" },
          [
            _c("label", [_vm._v(_vm._s(_vm.$t("report.viewAs")))]),
            _vm._v(" "),
            _c(
              "a-radio-group",
              {
                attrs: { size: "small" },
                model: {
                  value: _vm.unit,
                  callback: function ($$v) {
                    _vm.unit = $$v
                  },
                  expression: "unit",
                },
              },
              [
                _c("a-radio-button", { attrs: { value: "seconds" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("report.second"))),
                ]),
                _vm._v(" "),
                _c("a-radio-button", { attrs: { value: "minutes" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("report.minute"))),
                ]),
                _vm._v(" "),
                _c("a-radio-button", { attrs: { value: "hours" } }, [
                  _vm._v(" " + _vm._s(_vm.$t("report.hour"))),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.tableMode
        ? _c("TableView", {
            attrs: { cols: _vm.getCols(), rows: _vm.getRows() },
          })
        : _c("StackedAreaChart", {
            attrs: {
              title:
                _vm.aggregationType === "avg"
                  ? _vm.$t("report.averageSessionDuration")
                  : _vm.$t("report.totalSessionDuration"),
              "x-axis-data": _vm.getXAxisData(),
              legends: _vm.legends,
              colors: _vm.colors,
              series: _vm.getSeries(),
            },
          }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "stats" },
        [
          _c("StatCard", {
            attrs: {
              title: _vm.$t("report.total"),
              value: _vm.stats.TotalDuration,
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: _vm.$t("report.average"),
              value: _vm.stats.AverageDuration,
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: _vm.$t("report.max"),
              value: _vm.stats.MaxDuration,
            },
          }),
          _vm._v(" "),
          _c("StatCard", {
            attrs: {
              title: _vm.$t("report.min"),
              value: _vm.stats.MinDuration,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }